import React from 'react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Am trecut de la oboseală cronică la o viață în care pot respira cu adevărat. Nu credeam că e posibil să mă simt din nou eu. Fără rușine. Cu iubire.',
    author: 'Irina M.',
    role: 'Clientă'
  }, {
    quote: 'Nu am înțeles până la tine că totul e programare și că pot alege ce program păstrez. Mi-ai dat înapoi controlul asupra propriei vieți.',
    author: 'Adriana C.',
    role: 'Clientă'
  }, {
    quote: 'Nu credeam că uleiurile, cristalele și vulnerabilitatea pot merge împreună cu știința. Mi-ai arătat că da și că funcționează.',
    author: 'Mirela D.',
    role: 'Clientă'
  }];
  return <section className="w-full bg-gray-bg py-20 px-4 sm:px-6 lg:px-8" data-id="element-234" data-mp="184ugz4trmiwj">
      <div className="max-w-7xl mx-auto" data-id="element-235" data-mp="2ygimk0rr90gq">
        <div className="text-center mb-16" data-id="element-236" data-mp="2ydcy8nqya2m2">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-dark mb-4" data-id="element-237" data-mp="32frdyyzbom94">
            Ce spun oamenii care au lucrat cu mine
          </h2>
          <div className="w-16 h-0.5 bg-primary mx-auto" data-id="element-238" data-mp="2uz81nnrgat7m"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-239" data-mp="2q27uf9iv7kex">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white rounded-2xl p-8 shadow-lg flex flex-col justify-between h-full relative" data-id="element-240" data-mp="34t8bg2xogmmo" data-mpi={index}>
              <div className="text-6xl text-light opacity-30 absolute top-4 left-6 font-serif" data-id="element-241" data-mp="2c38hgz4pstyl">
                "
              </div>
              <p className="text-body italic leading-relaxed mb-8 relative z-10 pt-4" data-id="element-242" data-mp="275zyiwbqslwa">
                {testimonial.quote}
              </p>
              <div className="mt-auto" data-id="element-243" data-mp="2h1jol23mkqd4">
                <div className="w-10 h-0.5 bg-medium mb-3" data-id="element-244" data-mp="2h0i5qbgdazku"></div>
                <p className="font-bold text-dark" data-id="element-245" data-mp="19m5ju6otatw">
                  {testimonial.author}{' '}
                  <span className="text-medium font-normal" data-id="element-246" data-mp="3sfwzz7h6zdc9">
                    · {testimonial.role}
                  </span>
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}